import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import FinancialAdvisory from "./views/Financial-Advisory.vue";
import AssetManagement from "./views/Asset-Management.vue";
import Transactions from "./views/Transactions.vue";
import Leadership from "./views/Leadership.vue";
import FirmOverview from "./views/FirmOverview.vue";
import Careers from "./views/Careers.vue";
import Contact from "./views/Contact.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "CS Capital Advisors - Financial Advisory & Asset Management",
        metaTags: [
          {
            name: "title",
            content:
              "CS Capital Advisors - Financial Advisory & Asset Management"
          }
        ]
      }
    },
    {
      path: "/financial-advisory",
      name: "Financial-Advisory",
      component: FinancialAdvisory
    },
    {
      path: "/asset-management",
      name: "Asset-Management",
      component: AssetManagement
    },
    {
      path: "/transactions",
      name: "Transactions",
      component: Transactions
    },
    {
      path: "/leadership",
      name: "Leadership",
      component: Leadership
    },
    {
      path: "/firm-overview",
      name: "Firm-Overview",
      component: FirmOverview
    },
    {
      path: "/careers",
      name: "Careers",
      component: Careers
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact
    }
  ]
});
